export const RadialOverlay = () => (
  <div
    className={`
      absolute
      top-0
      right-0
      bottom-0
      left-0
      oveflow-hidden
      bg-center
      z-30
      pointer-events-none
      mix-blend-overlay
    `}
    style={{
      backgroundImage: `url('/overlay-radial.svg')`,
      backgroundSize: '105%',
    }}
  />
);
